export default "__VITE_ASSET__BavQsLrR__"